export const MARKETPLACE_BASE_NAME = 'provider-profile-marketplace';

export const SHOW_AVAILABILITY_BADGES_COM_793_TEST_NAME = 'show_availability_badges_com_793_20220421';
export const SHOW_AVAILABILITY_BADGES_COM_793_TEST_PERCENT = 0.5;

export const COM_793_STYLE_PERCENTAGES = {
  Barber: {
    min_percent_booked: 42,
    max_percent_booked: 78,
  },
  Braids: {
    min_percent_booked: 48,
    max_percent_booked: 93,
  },
  Eyebrows: {
    min_percent_booked: 38,
    max_percent_booked: 72,
  },
  Eyelashes: {
    min_percent_booked: 42,
    max_percent_booked: 62,
  },
  'Hair Color': {
    min_percent_booked: 38,
    max_percent_booked: 79,
  },
  Highlights: {
    min_percent_booked: 53,
    max_percent_booked: 88,
  },
  Knots: {
    min_percent_booked: 38,
    max_percent_booked: 93,
  },
  Locs: {
    min_percent_booked: 63,
    max_percent_booked: 81,
  },
  Makeup: {
    min_percent_booked: 38,
    max_percent_booked: 89,
  },
  Manicure: {
    min_percent_booked: 38,
    max_percent_booked: 89,
  },
  "Men's Haircut": {
    min_percent_booked: 42,
    max_percent_booked: 78,
  },
  'Natural Hair': {
    min_percent_booked: 32,
    max_percent_booked: 71,
  },
  'Sets & Styles': {
    min_percent_booked: 41,
    max_percent_booked: 78,
  },
  Skincare: {
    min_percent_booked: 32,
    max_percent_booked: 78,
  },
  Style: {
    min_percent_booked: 43,
    max_percent_booked: 77,
  },
  Waxing: {
    min_percent_booked: 32,
    max_percent_booked: 69,
  },
  Weaves: {
    min_percent_booked: 48,
    max_percent_booked: 93,
  },
  Wigs: {
    min_percent_booked: 48,
    max_percent_booked: 93,
  },
  "Women's Haircut": {
    min_percent_booked: 38,
    max_percent_booked: 87,
  },
};
